export const classNames = (...classes) => classes.filter(Boolean).join(' ');
